import { useEffect, useState } from 'react';
import { AppCheck, onTokenChanged } from 'firebase/app-check';
import RouteLoading from '../apps/phio/components/RouteLoading';

interface Props {
    appCheck: AppCheck;
    children: JSX.Element;
}

export default function AppCheckProvider({ appCheck, children }: Props) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onTokenChanged(appCheck, (result) => {
            if (result.token) {
                setLoading(false);
                return;
            }
            console.log(
                'There may be issues with fetching the AppCheck token!',
            );
        });

        return () => {
            unsubscribe();
        };
    });
    return loading ? <RouteLoading /> : children;
}
